var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLongRightGrayNeutral25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24x24/ArrowLong_Right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24x24/ArrowLong_Right",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6027304,11 L16.3425076,7.70314549 C15.9541711,7.31044563 15.9577083,6.67729053 16.3504081,6.288954 C16.743108,5.90061747 17.3762631,5.90415464 17.7645996,6.29685451 L22.6606057,11.2478719 C22.7431528,11.321536 22.8123701,11.4082939 22.8663149,11.5034921 C22.9054543,11.571839 22.9358621,11.6438045 22.9575473,11.717772 C23.0507609,12.0306735 22.9956549,12.3892645 22.7405358,12.6698468 C22.73003,12.6814717 22.7192031,12.6929085 22.708055,12.7041457 L17.7645996,17.7031455 C17.3762631,18.0958454 16.743108,18.0993825 16.3504081,17.711046 C15.9577083,17.3227095 15.9541711,16.6895544 16.3425076,16.2968545 L19.6027304,13 L1.99799805,12.9999999 C1.4457133,13 0.997998051,12.5522847 0.997998051,11.9999999 C0.997998051,11.4477153 1.4457133,11 1.99799805,10.9999999 L19.6027304,11 Z",
    id: "Path",
    fill: "#e1e2e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongRightGrayNeutral25);
export default __webpack_public_path__ + "static/media/ArrowLong_Right_GrayNeutral25.0efb95aecc4cec4f44d9f0dfd061fd4a.svg";
export { ForwardRef as ReactComponent };